import ListDepartamentosImpl from 'components/departamentos/ListDepartamentosImpl'
import React from 'react'
import { Col, Row } from 'reactstrap'

const ViewDepartamentos = () => {
  return (<Row>
    <Col>
      <ListDepartamentosImpl></ListDepartamentosImpl>
    </Col>
  </Row>
  )
}

export default ViewDepartamentos